import { APPOINTMENT_TABLE_HEADERS } from "./appointmentViewShared";

export default function AppointmentTableHead() {
  return (
    <thead className="bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-700 dark:to-slate-800 border-b-2 border-slate-200 dark:border-slate-600">
      <tr>
        {APPOINTMENT_TABLE_HEADERS.map((col) => (
          <th
            key={col.key}
            className={`px-6 py-4 text-xs font-bold text-slate-700 dark:text-slate-200 uppercase tracking-wider ${
              col.align === "center"
                ? "text-center w-32"
                : "text-left"
            }`}
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
}
